const e = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M39.9856%200V40L0%200H39.9856Z'%20fill='%2300C19B'/%3e%3c/svg%3e";
export {
  e as default
};
